(function () {
  'use strict';

  if (window.cmBindCarouselScrollbar) return;

  window.cmBindCarouselScrollbar = function (track, bar, thumb) {
    if (!track || !bar || !thumb || bar.dataset.cmScrollBound === 'true') return;
    bar.dataset.cmScrollBound = 'true';

    var dragging = false;

    function metrics() {
      var scrollW = track.scrollWidth;
      var clientW = track.clientWidth;
      var maxScroll = Math.max(scrollW - clientW, 0);
      var barW = bar.clientWidth;
      var thumbW = thumb.offsetWidth;
      var maxThumb = Math.max(barW - thumbW, 0);
      return { scrollW: scrollW, clientW: clientW, maxScroll: maxScroll, barW: barW, thumbW: thumbW, maxThumb: maxThumb };
    }

    function scrollToClientX(clientX) {
      var m = metrics();
      if (!m.maxScroll) return;
      var rect = bar.getBoundingClientRect();
      var x = clientX - rect.left - m.thumbW / 2;
      var pct = m.maxThumb > 0 ? Math.min(Math.max(x / m.maxThumb, 0), 1) : 0;
      track.scrollLeft = pct * m.maxScroll;
    }

    bar.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      event.preventDefault();
      dragging = true;
      bar.classList.add('is-dragging');
      bar.setPointerCapture(event.pointerId);
      scrollToClientX(event.clientX);
    });

    bar.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      scrollToClientX(event.clientX);
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      bar.classList.remove('is-dragging');
    }

    bar.addEventListener('pointerup', endDrag);
    bar.addEventListener('pointercancel', endDrag);
    bar.addEventListener('lostpointercapture', endDrag);
  };
})();
